import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { SOURCE_KEY } from './Constants';

/**
 * @function useSourceIdCookie - manages sourceid cookie, window.location state
 * 
 * @return {sourceid, location} 
 * sourceid:String - cookie value or undefined if there is no cookie with the given name.
 * location:Obj - window.location Obj
 *
 * Cookie expiration has a default value of 7 days if not defined
 */
export const useSourceIdCookie = () => 
{
    const [{ sourceid }, setCookie ] = useCookies([`${SOURCE_KEY}`]);
    const [location, setLocation] = useState(null)

    useEffect(() => 
    {
        const { search = null } = window?.location
        setLocation(window?.location)
        if (!search) return
        const sourceIdParam = new URLSearchParams(search).get(`${SOURCE_KEY}`);
        if (sourceIdParam) 
        {
            setCookie(`${SOURCE_KEY}`, `${sourceIdParam.substring(0, 99)}`, {
                path: '/', // make accessible for all pages
                expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 365 days
            });
        }
    }, [sourceid, setCookie]);

    return {
        sourceid,
        location,
        setCookie,
    };
};
